export const types = {
  SNACKBAR_SHOW: 'Show Snackbar',
  SNACKBAR_HIDE: 'Hide Snackbar',
  SNACKBAR_DEFAULT: 'Set Default Options for Snackbar',
};

export default {
  namespaced: true,
  state: {
    show: false,
    message: '',
    options: {},
    defaultOptions: {
      multiLine: true,
      timeout: 6000,
      bottom: true,
      dismissable: true,
      dismissableText: 'Dismiss',
      dismissableColor: 'error',
    },
  },
  getters: {
    isShown: state => state.show,
    isHidden: state => !state.show,
  },
  actions: {
    show({ commit, dispatch }, { message, options }) {
      dispatch('hide');
      commit(types.SNACKBAR_SHOW, { message, options });
    },
    hide({ commit, getters }) {
      if (getters.isShown) {
        commit(types.SNACKBAR_HIDE);
      }
    },
  },
  mutations: {
    [types.SNACKBAR_SHOW](state, { message, options }) {
      state.show = true;
      state.message = message;
      state.options = Object.assign(state.defaultOptions, options);
    },
    [types.SNACKBAR_HIDE](state) {
      state.show = false;
      state.message = '';
      state.options = {};
    },
    [types.SNACKBAR_DEFAULT](state, defaultOptions) {
      state.defaultOptions = Object.assign(state.defaultOptions, defaultOptions);
    },
  },
};
